(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('EditAddressController', EditAddressController);

    EditAddressController.$inject = ['$uibModalInstance', 'InvoicesService', 'user', '$filter', '$state', '$stateParams', '$sce', 'FindClientsService'];

    function EditAddressController($uibModalInstance, InvoicesService, user, $filter, $state, $stateParams, $sce, FindClientsService) {
        var vm = this;

        vm.user             = user;
        vm.ok               = ok;
        vm.cancel           = cancel;        
        
        vm.addresses         = [];
        vm.loadAddresses    = loadAddresses;
        vm.branchSelected   = [];
        vm.getAddress        = getAddress;

        vm.customer         = [];

        vm.formatAddress    = formatAddress;

        activate();

        function activate() {
            vm.loadAddresses();     
            if (vm.user.address) {
                vm.customer.address = vm.user.address.toString().replace(/<br>/g, '\n');         
            }
            console.log(vm.user) 
        }


        function ok() {    
            vm.user.address = vm.customer.address; 
            // vm.user.addressHTML = $sce.trustAsHtml(vm.customer.address.replace(/\n/g, '<br>'));
            // vm.user.addressHTML = $sce.trustAsHtml(vm.customer.address.replace(/\n/g, '<br>'));
            let query = {};
            query['address'] = vm.user.address.replace(/\n/g, '<br>');
            InvoicesService.updateAddress(vm.user.id, query).then(function(data) {
                alertify.success('Address updated!');
            });
            // console.log(vm.user);
            // vm.invoicesFormController.setCountry(vm.user);
            $uibModalInstance.close();  
        }

        function cancel() {
            $uibModalInstance.close();
        }

        function loadAddresses() {
            //debugger;
            FindClientsService.getAddresses(vm.user['exhibitor'].user_id).then(function(response) {
                vm.addresses = response.data;
                if (vm.addresses.length > 0) {
                    vm.addressSelected = {id: vm.addresses[0].id, name: vm.addresses[0].address};                                
                }
            }).catch(function(err) {
            });
        }

        function getAddress() {
            var address_id = vm.addressSelected.id;
            var address = $filter('filter')(vm.addresses, {id: address_id})[0];
            vm.customer.address = vm.formatAddress(address);      
        }

        function formatAddress(address) {
            return address.address + '\n' + 
                address.city_name + ', ' + 
                address.region_name + ' ' +
                address.zip_code + '\n' + 
                address.country_name;
        }
        
    }

})();